var React = require('react');

function Sigma (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M360 352h-48a24 24 0 0 0-24 23.44V480h64a32 32 0 0 0 32-32v-72a24 24 0 0 0-24-24zm-8-320h-64v104.56A24 24 0 0 0 312 160h48a24 24 0 0 0 24-24V64a32 32 0 0 0-32-32z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M288 136v-8H142.24l109.09 128-109.09 128H288v-8.56V480H52a52 52 0 0 1-42-82.64L132.65 256 10 114.6A52 52 0 0 1 52 32h236v104z","className":"fa-primary","key":2})]);
}

Sigma.defaultProps = {"viewBox":"0 0 384 512","className":"icon"};

module.exports = Sigma;

Sigma.default = Sigma;
